import React from 'react';
import Button from '../Utils/Button';
import { restUrl } from '../../env';
import { WaitUntilLoggedIn } from '../Core/LoginManager';
import axios from 'axios';
import { gameStateManager } from '../../App';
import { Navigate } from "react-router-dom";
import BugReportRow from './BugReportRow';
import '../../css/bugReportRow.css';

export default class BugReports extends React.Component
{
  state = {
    bugReports: []
  };

  async componentDidMount()
  {
    await WaitUntilLoggedIn( async () =>
    {
      await this.updateBugReportsList();
    } );
  }

  async updateBugReportsList()
  {
    const response = await axios.post( `${restUrl}/admin/bugReports`, {}, { withCredentials: true } );

    if( response.data.success )
    {
      this.setState( { bugReports: response.data.data } );
    }
    else
    {
      console.log( "Failed to get admin bugReports: ", response.data.error );
    }
  }

  render()
  {
    return (
      <div style={ { display: 'flex', flexDirection: 'column', height: '100%' } }>
        <div className="bug-reports-header">
          <h4>Bug Reports</h4>
          <Button
            className="refresh-button"
            onClick={ () =>
            {
              this.updateBugReportsList();
            } }>
            Refresh
          </Button>
        </div>

        <div className="bug-reports-container">
          { this.state.bugReports.map( el => (
            <BugReportRow bugReportData={ el } key={ el.roomId + "" } />
          ) ) }

          { this.state.bugReports.length === 0 && (
            <div style={ { textAlign: 'center', padding: '40px', color: '#6c757d' } }>
              No bug reports found. Click refresh to check for new reports.
            </div>
          ) }
        </div>
      </div>
    );
  }
}
